<script setup lang="ts">
import { useI18n } from '@fusapp-work/shell'
import ShellIcon from './ShellIcon.vue'
import { appReturnHref } from './appReturn'

// Console v2.dc.html:63-66: the App return is a link. Without a configured App target it stays an inert,
// aria-disabled link whose reason is announced, instead of pointing at a guessed address.
const { t } = useI18n()
const href = appReturnHref()
</script>

<template>
  <a
    class="console-app-return"
    data-testid="shell-app-return"
    :href="href"
    :role="href ? undefined : 'link'"
    :aria-disabled="href ? undefined : 'true'"
    :aria-label="t('consoleShell.appReturn')"
    :aria-describedby="href ? undefined : 'console-app-return-reason'"
  >
    <ShellIcon name="app" /><span class="console-return-label">{{ t('consoleShell.appReturn') }}</span>
  </a><p
    v-if="!href"
    id="console-app-return-reason"
    class="console-app-return-reason console-sr-only"
  >
    {{ t('consoleShell.appReturnUnavailable') }}
  </p>
</template>
